import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import MainLayout from "../../../../commons/layout/MainLayout/index";
import ROUTERS from "../../../../commons/constans/router";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import TextInputComponent from "../../../../commons/components/Forms/TextInputComponent";
import CheckboxComponent from "../../../../commons/components/Forms/CheckboxComponent";
import ButtonComponent from "../../../../commons/components/Forms/ButtonComponent";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent";
import { resetState } from "../../redux/actions";

type Props = {};

const RegisterComponent = ({}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [messages, setMessages] = useState("");

  const [dataLogin, setDataLogin] = useState({
    username: "",
    password: "",
    remember_me: false,
  });

  useEffect(() => {}, []);

  return (
    <MainLayout pageID={"register-page"} displayBottomNav={false}>
      <HeaderHs2 title={"회원가입"} labelLeft={true} labelRight={false} />
      <div className="wrapper">
        <div className="container">
          <div className>
            <div className>
              <div className="input-component">
                <label className="required">이름</label>
                <div className="input-group">
                  <input type="text" placeholder="이름을 입력하세요." />
                </div>
              </div>
              <div className="input-component">
                <label className="required">휴대폰번호</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="input-group__input_form"
                    placeholder="(-)를 제외하고 입력해주세요. "
                  />
                  <button type="button" className="btn btn-outline-register">
                    재발송
                  </button>
                </div>
                <div className="input-group verification-code">
                  <input
                    type="text"
                    className="input-group__input_form verification-code__position"
                    placeholder="인증번호를 입력해주세요. "
                  />
                  <button type="button" className="btn btn-outline-register">
                    인증
                  </button>
                  <span className="time-count-down">04:30</span>
                </div>
                {/* <span class="input-error show">*비밀번호가 일치하지않습니다.</span> */}
              </div>
              <div className="input-component">
                <label className="required">이메일 주소</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="col-10"
                    placeholder="아이디 입력"
                  />
                  <label className="email col-2">@</label>
                </div>
                {/* <span class="input-error show">*비밀번호가 일치하지않습니다.</span> */}
              </div>
              <div className="input-component">
                <div className="input-group">
                  <input
                    type="text"
                    className="input-group__input_form"
                    placeholder="선택하세요."
                  />
                  <button type="button" className="btn btn-outline-register">
                    중복확인
                  </button>
                  <label htmlFor className="note-email">
                    * 가입한 이메일 주소는 로그인 아이디로 사용되며, 변경이{" "}
                    <br />
                    불가능합니다.
                  </label>
                </div>
                {/* <span class="input-error show">*비밀번호가 일치하지않습니다.</span> */}
              </div>
              <div className="input-component">
                <label className="required">비밀번호</label>
                <div className="input-group">
                  <input type="password" placeholder="이름을 입력하세요." />
                </div>
              </div>
              <div className="input-component">
                <label className="required">비밀번호 확인</label>
                <div className="input-group">
                  <input
                    type="password"
                    className
                    placeholder="이름을 입력하세요."
                  />
                </div>
                <span className="input-error show">
                  *비밀번호가 일치하지않습니다.
                </span>
              </div>
              <label className="checkbox-component">
                <div className="checkbox">
                  <input type="checkbox" />
                  <span />
                </div>
                <div className="label d-flex align-start">
                  <label className="agree-terms unCheck">
                    약관에 동의합니다.
                  </label>
                  <label htmlFor className="view-terms unCheck">
                    (이용약관 및 개인정보 취급방침 보기)
                  </label>
                </div>
              </label>
              <button type="button" className="btn btn-block btn-primary">
                회원가입
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RegisterComponent;
